/*global define*/
define(function () {
    'use strict';

    function PromisesResolver(AdminDescription) {
        return AdminDescription.getPromisesResolver();
    }

    PromisesResolver.$inject = ['AdminDescription'];

    return PromisesResolver;
});



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin/Crud/misc/PromisesResolver.js
 **/